export type AuthHeaderProvider = (forceRefresh?: boolean) => Promise<string | undefined>;

interface AuthHeaderProviderRef {
  current: AuthHeaderProvider | undefined;
}

const authHeaderProviderRef: AuthHeaderProviderRef = {
  current: undefined,
};

export function getAuthHeaderProvider(): AuthHeaderProvider | undefined {
  return authHeaderProviderRef.current;
}

export function setAuthHeaderProvider(provider: AuthHeaderProvider | undefined): void {
  authHeaderProviderRef.current = provider;
}
